import * as React from "react";
import { useSelector } from "react-redux";

import { Box, Typography} from "@mui/material";
import Logo from "../../../ui-components/Logo";
import WebOnboardingButton from "../../../ui-components/Buttons/WebOnboardingButton";

export default function WebStart({
        onChangeWebStyleLayout = () => {}
    }) 
{
	const client = useSelector((state) => state.client || {});

    React.useEffect(() => {
        onChangeWebStyleLayout({
            style: {
                backgroundColor: "#148e8e",
                borderBottom: "60px solid #016d7c",
                hideFooter: false,
                // justifyContent: "center",
            }
        });
    }, [onChangeWebStyleLayout]);

	return (
		<React.Fragment>
			<Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                }}
            >
                {client?.details?.logo?.absolute ? (
                    <img
                        alt="logo"
                        src={client.details.logo.absolute}
                        style={{
                            maxWidth: "22rem",
                            maxHeight: "11rem",
                        }}
                    />
                ) : <Logo width="80px" />}

                <Box sx={{
                    textAlign: "center",
                    marginTop: "40px",
                }}>
                    <Typography
                        component="h1"
                        sx={{
                            fontSize: "2.5em",
                            marginTop: "0px",
                            marginBottom: "10px",
                            textAlign: "center",
                            fontWeight: "bold",
                            "@media (max-width: 1024px), (max-height: 768px)": {
                                fontSize: "2em",
                            },
                            "@media (max-width: 800px), (max-height: 600px)": {
                                fontSize: "2em",
                            },
                        }}
                    >Language, Literacy & Numeracy Quiz</Typography>
                </Box>
            </Box>

            <Box sx={{
                textAlign: "center",
                marginTop: "48px",
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
            }}>
                <WebOnboardingButton url="/info" title="Start"/>
            </Box>
		</React.Fragment>
	);
}